import { PreviewSections } from 'Core/interfaces'
import { entityToLabelValue } from 'Core/utils'

import { DataReport, GenerateReportFormFields } from '../types'

import { formatParameters } from './helpers'

export const parameterTypeValue = {
	[PreviewSections.Text]: null,
	[PreviewSections.Date]: null,
	[PreviewSections.DateRange]: null,
	[PreviewSections.Checkbox]: false,
	// undefined because of search select clear function
	[PreviewSections.Find]: undefined,
	[PreviewSections.Multiple]: undefined,
	[PreviewSections.Single]: null
}

export interface FormatParameters extends Omit<DataReport.Basic, 'value'> {
	parameterType: DataReport.ParametersTypeOptions
}

export const DEFAULT_VALUES: DataReport.Form = {
	[GenerateReportFormFields.reportWhereParameters]: [],
	[GenerateReportFormFields.sqlParameters]: [],
	[GenerateReportFormFields.reportColumnIdsParameters]: []
}

export const getDefaultValues = (reportData?: DataReport.Data): DataReport.Form => {
	if (!reportData) {
		return DEFAULT_VALUES
	}
	return {
		[GenerateReportFormFields.reportWhereParameters]: formatParameters(
			reportData.reportWhereParameters
		),
		[GenerateReportFormFields.sqlParameters]: formatParameters(reportData.sqlParameters),
		[GenerateReportFormFields.reportColumnIdsParameters]:
			reportData.reportColumns.map(entityToLabelValue)
	}
}
